import type { NavigateFunction } from "react-router";
import { deprecated } from "typesafe-actions";

import type { IStatusError } from "@/shop/types/errors";
import type { IRfqPatch, IRfqTransaction } from "@/shop/types/shopping/rfq";

const { createStandardAction } = deprecated;

/** Start rfq transaction */
export const startRfq = createStandardAction("START_RFQ").map((payload: { navigate: NavigateFunction; includeOrderPositions?: boolean }) => ({
  payload
}));

/** Intercept Start RFQ Failure e.g. insufficient rights   */
export const startRfqFail = createStandardAction("START_RFQ_FAIL").map((payload: IStatusError) => ({
  payload,
  error: true
}));

/** Fetch rfq transaction */
export const fetchRfq = createStandardAction("FETCH_RFQ").map((payload: string) => ({
  payload
}));

export const fetchRfqStart = createStandardAction("FETCH_RFQ_START").map((payload: string) => ({
  payload
}));

export const fetchRfqSuccess = createStandardAction("FETCH_RFQ_SUCCESS").map((payload: IRfqTransaction) => ({
  payload
}));

export const fetchRfqFail = createStandardAction("FETCH_RFQ_FAIL").map((payload: IStatusError) => ({
  payload,
  error: true
}));

export const addRfqAttachment = createStandardAction("ADD_RFQ_ATTACHMENT").map((payload: { posId: string; file: File }) => ({ payload }));

export const removeRfqAttachment = createStandardAction("REMOVE_RFQ_ATTACHMENT").map((payload: { posId: string }) => ({ payload }));

export const updateRfq = createStandardAction("UPDATE_RFQ").map((payload: IRfqPatch) => ({
  payload
}));

export const submitRfq = createStandardAction("SUBMIT_RFQ").map((payload: IRfqPatch) => ({
  payload
}));

export const submitRfqSuccess = createStandardAction("SUBMIT_RFQ_SUCCESS")();

export const submitRfqFail = createStandardAction("SUBMIT_RFQ_FAIL").map((err?: IStatusError) => ({ payload: err, error: true }));
